'use strict';

require('../modules/models/companyLegacy.js');
require('../modules/models/company.js');
require('../modules/data/compareData.js');
require('../modules/collections/companyData.js');
require('../modules/data/cacheLayer.js');
require('../modules/data/dataUpdatePoller.js');
require('../modules/data/companyData.js');
require('../apps/reports/app.js');
require('../apps/reports/models/slide.js');
